import React from "react";
import "./Frame6.css";

function Frame6(props) {
  const { className } = props;

  return (
    <div className={`frame-6-10 ${className || ""}`}>
      <div className="machine-arretee inter-medium-dark-fern-18-1px">MACHINE ARRETEE</div>
    </div>
  );
}

export default Frame6;
